import {Stack} from '@mui/material'
import React from 'react'

function formatAmount(num: unknown): string {
  if (num === null || num === undefined || num === '') {
    return ''
  }

  const value = Number(num)
  if (Number.isNaN(value)) {
    return String(num)
  }

  const locale = localStorage.getItem('i18nextLng') || 'en'
  const hasFraction = value % 1 !== 0

  return value.toLocaleString(locale, {
    minimumFractionDigits: hasFraction ? 2 : 0,
    maximumFractionDigits: 2,
  })
}

export default function FixedNumber({num, isNum, fs, fw, color, center}: any) {
  const currency = localStorage.getItem('currency')

  return (
    <Stack
      sx={{
        fontSize: fs || 'auto',
        fontWeight: fw || 'auto',
        color: color || 'auto',
        textAlign: center,
      }}
      width={'max-content'}
    >
      {' '}
      {!isNum && currency} {formatAmount(num)}
    </Stack>
  )
}
